import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useLandingContent } from '../useLandingContent';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  const { content } = useLandingContent();
  const faqs = content.faqs || [];
  return (
    <section id="faq" className="py-20 sm:py-28 bg-stone-50" data-testid="section-faq">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-[11px] font-black text-primary uppercase tracking-widest mb-3">— Domande Frequenti</p>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-stone-900 leading-[1.1]">
            Le risposte<br /><span className="text-stone-500">che cercavi.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <article key={i} data-testid={`faq-${i}`}
                className={`bg-white border rounded-lg transition-all ${isOpen ? 'border-primary shadow-lg' : 'border-stone-200 hover:border-stone-300'}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4">
                  <h3 className="text-base sm:text-lg font-bold text-stone-900 pr-2">{f.q}</h3>
                  <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${isOpen ? 'bg-primary text-white rotate-180' : 'bg-stone-100 text-stone-600'}`}>
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 sm:px-6 pb-5 sm:pb-6 -mt-2">
                    <p className="text-stone-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
